import { AsyncThunkPayloadCreator, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../rootReducer';

export type ErrorState = {
    topError: string | null;
    signinError: string | null;
    popupError: string | null;
};

const initialState: ErrorState = {
    topError: null,
    signinError: null,
    popupError: null,
};

export const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setTopError: (state, action: PayloadAction<string | null>) => {
            state.topError = action.payload;
        },
        setSigninError: (state, action: PayloadAction<string | null>) => {
            state.signinError = action.payload;
        },
        setPopupError: (state, action: PayloadAction<string | null>) => {
            state.popupError = action.payload;
        },
    },
    extraReducers: {},
});

export const withTopError = <Returned, Args = void, ThunkApiConfig = unknown>(
    payloadCreator: AsyncThunkPayloadCreator<Returned, Args, ThunkApiConfig>,
    msg: string
): AsyncThunkPayloadCreator<Returned, Args, ThunkApiConfig> => async (args, thunkAPI) => {
    try {
        return await payloadCreator(args, thunkAPI);
    } catch (err) {
        const dispatch = thunkAPI.dispatch;
        dispatch(setTopError(msg));
        throw err;
    }
};

export const { setTopError, setSigninError, setPopupError } = errorSlice.actions;

export const selectError = (state: RootState): ErrorState => state.error;

export const errorReducer = errorSlice.reducer;
